/**
 * Wonderly header behaviour.
 *
 * 1. Predictive dropdown clamping — the results panel is wider than the search field
 *    (>=750px). It's centered under the field but clamped to the viewport so it never
 *    causes horizontal overflow. Runs at all breakpoints.
 *
 * 2. Full-screen mobile drawer wiring — see setupDrawer().
 *
 * The desktop inline search scales down purely in CSS (its grid track has min 0 / max
 * 425px and the nav is pinned to one line), so there is no JS stacking/collapse logic.
 */
(function () {
  var DROPDOWN_MAX = 750; /* px */
  var VIEWPORT_MARGIN = 16; /* px gutter kept on each side of the dropdown */

  function init() {
    var header = document.querySelector('.header.header--middle-left');
    if (!header) return;

    /* Scope to the header's own field — the drawer also renders a .header__search-inline,
       and it appears earlier in the DOM (header-drawer is rendered before the search row). */
    var inlineSearch = header.querySelector('.header__search-inline-wrapper .header__search-inline');
    var desktop = window.matchMedia('(min-width: 990px)');

    setupDrawer();

    function positionDropdown() {
      if (!inlineSearch) return;
      var results = inlineSearch.querySelector('.predictive-search');
      if (!results) return;

      var vw = document.documentElement.clientWidth;
      var w = Math.min(DROPDOWN_MAX, vw - VIEWPORT_MARGIN * 2);
      var rect = inlineSearch.getBoundingClientRect();
      var center = rect.left + rect.width / 2;
      var left = center - w / 2; /* viewport-space left edge if perfectly centered */
      left = Math.max(VIEWPORT_MARGIN, Math.min(left, vw - VIEWPORT_MARGIN - w));

      results.style.width = w + 'px';
      results.style.left = left - rect.left + 'px'; /* convert to offset within the field */
      results.style.transform = 'none';
    }

    function update() {
      positionDropdown();
    }

    /* Full-screen drawer: the injected top region holds a search field (with submit/reset
       buttons) and a close X. Dawn's MenuDrawer auto-binds a "close the menu" handler to
       EVERY <button> inside the drawer, which would slam the menu shut when you use the
       search. A single capture-phase listener on the top region stops those clicks before
       they reach MenuDrawer's button handlers (default actions — form submit/reset, input
       focus — are unaffected). The close X is handled here too: it drives the real
       hamburger summary so the menu closes properly (resets the body scroll-lock). */
    function setupDrawer() {
      var drawer = header.querySelector('header-drawer');
      if (!drawer) return;
      var top = drawer.querySelector('[data-wonderly-drawer-top]');
      if (top) {
        top.addEventListener(
          'click',
          function (event) {
            if (event.target.closest('.menu-drawer__wonderly-close')) {
              var summary = drawer.querySelector('.menu-drawer-container > summary');
              if (summary) summary.click();
            }
            event.stopPropagation();
          },
          true
        );
      }

      /* Level-3 inline accordion . The grandchild list lives in the
         slide-in submenu panel and expands in place. Dawn's MenuDrawer auto-binds
         EVERY drawer <button> to closeSubmenu (which would slide the panel back), so
         a capture-phase listener handles the toggle and stops the click before it
         reaches that handler. */
      var nav = drawer.querySelector('.menu-drawer__navigation');
      if (nav) {
        nav.addEventListener(
          'click',
          function (event) {
            var toggle = event.target.closest('.menu-drawer__accordion-toggle');
            if (!toggle || !nav.contains(toggle)) return;
            event.preventDefault();
            event.stopPropagation();
            var expanded = toggle.getAttribute('aria-expanded') === 'true';
            toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
            var panel = document.getElementById(toggle.getAttribute('aria-controls'));
            if (panel) panel.hidden = expanded;
          },
          true
        );
      }
    }

    if ('ResizeObserver' in window) {
      new ResizeObserver(update).observe(header);
    }
    window.addEventListener('resize', update);
    if (typeof desktop.addEventListener === 'function') {
      desktop.addEventListener('change', update);
    }
    if (inlineSearch) {
      inlineSearch.addEventListener('focusin', positionDropdown);
      inlineSearch.addEventListener('input', positionDropdown);
    }
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(update);
    }
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
